import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';
import {
  fetchTinStatus,
  uploadProof,
  uploadSignature,
  submitTin,
  setDocumentId,
  setDocumentLoading,
  setTrackingNumber,
  setSignatureCanvas,
  saveAsDraft,
  retrieveDraft,
  deleteSession,
  toggleReturnRegistration,
  validateNPI,
  disableSaveAsDraft,
} from './actions';
import {
  TIN_STATUS,
  TIN_SUBMISSION,
  UPLOAD_DOCUMENT,
  SET_DOCUMENT_ID,
  SET_DOCUMENT_LOADING,
  SET_TRACKING_NUMBER,
  SET_SIGNATURE_CANVAS,
  SAVE_AS_DRAFT,
  RETRIEVE_DRAFT,
  DELETE_SESSION,
  RETURN_TO_REGISTRATION,
  NPI_VALIDATIONS,
  DISABLE_SAVEASDRAFT,
} from './constants';

const tinStatusSelector = (state) => {
  return state.tin;
};

export const useTinRegistration = {
  state: () => {
    return useSelect(tinStatusSelector);
  },
  actions: () => {
    return {
      fetchTinStatus: useAction(fetchTinStatus, {
        saga: useAsync(TIN_STATUS),
      }),
      uploadProof: useAction(uploadProof, {
        saga: useAsync(UPLOAD_DOCUMENT),
      }),
      uploadSignature: useAction(uploadSignature, {
        saga: useAsync(UPLOAD_DOCUMENT),
      }),
      setDocumentId: useAction(setDocumentId, {
        saga: useAsync(SET_DOCUMENT_ID),
      }),
      setTrackingNumber: useAction(setTrackingNumber, {
        saga: useAsync(SET_TRACKING_NUMBER),
      }),
      setDocumentLoading: useAction(setDocumentLoading, {
        saga: useAsync(SET_DOCUMENT_LOADING),
      }),
      submitTin: useAction(submitTin, {
        saga: useAsync(TIN_SUBMISSION),
      }),
      setSignatureCanvas: useAction(setSignatureCanvas, {
        saga: useAsync(SET_SIGNATURE_CANVAS),
      }),
      saveAsDraft: useAction(saveAsDraft, {
        saga: useAsync(SAVE_AS_DRAFT),
      }),
      retrieveDraft: useAction(retrieveDraft, {
        saga: useAsync(RETRIEVE_DRAFT),
      }),
      deleteSession: useAction(deleteSession, {
        saga: useAsync(DELETE_SESSION),
      }),
      toggleReturn: useAction(toggleReturnRegistration, {
        saga: useAsync(RETURN_TO_REGISTRATION),
      }),
      validateNPI: useAction(validateNPI, {
        saga: useAsync(NPI_VALIDATIONS),
      }),
      disableSaveAsDraft: useAction(disableSaveAsDraft, {
        saga: useAsync(DISABLE_SAVEASDRAFT),
      }),
    };
  },
};
